/**
 * Generate an index for each year in
 *
 * @param {[any]} data - TimelineViewData
 * @returns {Object} indexes - Index of years to slide indexes
 */
export default function (data) {
    const imageIndexToDialIndex = [];
    const dialIndexToImageIndex = [];
    const dialIndexByResults = [];
    const resultsByYear = [];

    const startYear = +data[0].year;
    let newYear = 0;

    for (let i = 0; i < data.length; i++) {
        const dialIndex = +data[i].year - startYear;
        const curr = data[i];

        imageIndexToDialIndex.push(dialIndex);

        const next = data[i + 1];

        if (next) {
            const nextYear = +next.year;
            const currYear = +curr.year;
            const middle = Math.floor((nextYear - currYear) / 2);
            const nextDialIndex = nextYear - startYear;

            for (let j = 0; j < nextYear - currYear; j++) {
                dialIndexToImageIndex.push(newYear);

                if (j > middle) {
                    dialIndexByResults.push(nextDialIndex);
                } else {
                    dialIndexByResults.push(dialIndex);
                }

                if (j === 0) {
                    resultsByYear.push(true);
                } else {
                    resultsByYear.push(false);
                }
            }

            if (currYear !== nextYear) {
                newYear = i + 1;
            }
        } else {
            dialIndexByResults.push(dialIndex);
            dialIndexToImageIndex.push(newYear);
            resultsByYear.push(true);
        }
    }

    return {
        resultsByYear,
        dialIndexByResults,
        dialIndexToImageIndex,
        imageIndexToDialIndex
    };
}
